import {z} from 'zod'

import {TextFieldTypes} from './types'

export const createTextFieldSchema = <T extends TextFieldTypes>(field: T) =>
  z.object({
    [field]: z.string().optional()
  })

export const additionalNotesSchema = createTextFieldSchema('additionalNotes')
export const driverInstructionsSchema = createTextFieldSchema('driverInstructions')
export const poNumberSchema = createTextFieldSchema('poNumber')
